<div class="client-property-label">
	<span>{{ 'additional-questions.audit-dates.recert-audit-date' | translate }}</span>
	<change-label [visible]="isDesiredNextAuditDateChanged()" [changeSet]="changeSet"></change-label>
</div>
<div class="client-property">
	@if (product.additionalQuestions.desiredNextAuditDate) {
		<span>{{ product.additionalQuestions.desiredNextAuditDate | localizedDate | async }}</span>
	}
	@if (!product.additionalQuestions.desiredNextAuditDate) {
		<span class="placeholder">{{ 'additional-questions.audit-dates.date-not-provided' | translate }}</span>
	}
</div>
